import { idempotencyKey } from "./api.js";

export interface PaymentOperationAttempt {
  fingerprint: string;
  key: string;
}

/** Keep one key for one unchanged payment, block-sale or credit-use attempt. */
export function paymentOperationAttempt(
  previous: PaymentOperationAttempt | null,
  kind: "payment_received" | "lesson_block_sale" | "lesson_credit_use",
  input: unknown,
  createKey: () => string = idempotencyKey,
): PaymentOperationAttempt {
  const fingerprint = `${kind}:${JSON.stringify(input)}`;
  return previous?.fingerprint === fingerprint
    ? previous
    : { fingerprint, key: createKey() };
}
